export default "__VITE_ASSET__bh3G8dPd__"